const DEAL_SHEET_KEY_PREFIX = 'dealSheet_';

const STATIC_DEAL_SHEET_KEYS = new Set(['dealsheet1', 'dealsheet2', 'dealsheet3']);

export const dealSheetColumnKey = (detail = {}) => {
  const id = detail.dealSheetId ?? detail.id;
  return `${DEAL_SHEET_KEY_PREFIX}${id}`;
};

/** Gom danh sách dealsheet duy nhất từ rows[].dealSheetDetails. */
export const collectDealSheetDefinitions = (rows = []) => {
  const map = new Map();

  rows.forEach((row) => {
    const details = row.dealSheetDetails;
    if (!Array.isArray(details)) {
      return;
    }
    details.forEach((detail) => {
      const key = dealSheetColumnKey(detail);
      if (!map.has(key)) {
        map.set(key, {
          key,
          label: detail.dealSheetCode || detail.dealSheetName || key,
          type: 'currency',
          dealSheetId: detail.dealSheetId ?? detail.id,
        });
      }
    });
  });

  return Array.from(map.values()).sort((a, b) =>
    String(a.label).localeCompare(String(b.label), 'vi'),
  );
};

/** Chèn cột dealsheet động trước "Giá net", bỏ cột DS1/DS2/DS3 tĩnh. */
export const buildDealSheetColumns = (baseColumns = [], dealSheetDefs = []) => {
  const filtered = baseColumns.filter((column) => !STATIC_DEAL_SHEET_KEYS.has(column.key));
  if (!dealSheetDefs.length) {
    return filtered;
  }

  const giaNetIndex = filtered.findIndex((column) => column.key === 'giaNet');
  const insertIndex = giaNetIndex >= 0 ? giaNetIndex : filtered.length;

  return [
    ...filtered.slice(0, insertIndex),
    ...dealSheetDefs,
    ...filtered.slice(insertIndex),
  ];
};

/** Map dealSheetDetails[] → field dealSheet_<id> = discountAmount trên từng dòng. */
export const normalizeRowsDealSheets = (rows = []) =>
  rows.map((row) => {
    const details = row.dealSheetDetails;
    if (!Array.isArray(details) || !details.length) {
      return row;
    }

    const next = { ...row };
    details.forEach((detail) => {
      next[dealSheetColumnKey(detail)] = detail.discountAmount ?? detail.amount ?? null;
    });
    return next;
  });
